import React from 'react'

function PageLink({ link, itemClass }) {
    return (
        <li href={link.href} className={itemClass}>{link.text}</li>
    )
}

export default PageLink